import { render, staticRenderFns } from "./amenitie-card.vue?vue&type=template&id=d804efbe&scoped=true"
import script from "./amenitie-card.vue?vue&type=script&lang=js"
export * from "./amenitie-card.vue?vue&type=script&lang=js"
import style0 from "./amenitie-card.vue?vue&type=style&index=0&id=d804efbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d804efbe",
  null
  
)

export default component.exports